import { render, staticRenderFns } from "./revisar-avance-partidas.vue?vue&type=template&id=0d6e4043&scoped=true&"
import script from "./revisar-avance-partidas.vue?vue&type=script&lang=js&"
export * from "./revisar-avance-partidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6e4043",
  null
  
)

export default component.exports